import { Component, h } from 'preact'
import IdeaView from './IdeaView'
import IdeaStatusFilter from './filters/IdeaStatusFilter'
import Axios from 'axios'
import { IdeaStatus } from '../ideation-status/Types'
import { ProductAreaType } from '../product-areas/ProductAreaSelect'

interface Props {
  isGuest: boolean,
  ideas: Array<any>,
  ideationStatuses: Array<IdeaStatus>,
  productAreas?: Array<ProductAreaType>,
  currentUserId: number
}

interface State {
  ideas: Array<any>,
  selectedFilters: {
    [key: string]: string | null
  }
}

class IdeasOverview extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      ideas: props.ideas,
      selectedFilters: {
        ideationStatus: null
      }
    }

    this.updateFilters = this.updateFilters.bind(this)
  }

  async updateFilters (key: string, value: string | null) {
    const newFilters: {
      [key: string]: string | null
    } = { ...this.state.selectedFilters, [key]: value }

    this.setState({ selectedFilters: newFilters })

    let filterKeys = Object.keys(newFilters)
    filterKeys = filterKeys.filter(key => newFilters[key] !== null)

    const filterRequest = filterKeys.reduce((acc, filter) => {
      return `${acc}&${filter}=${newFilters[filter]}`
    }, '')

    const res = await Axios.get(`/community/api/topics?contentType=idea${filterRequest}&trashed=false`)
    if (res.data) {
      this.setState({ ideas: res.data.result })
    }
  }

  render ({ isGuest, currentUserId, ideationStatuses }: Props, { ideas, selectedFilters }: State) {
    return (
      <div className='ideas-overview-wrapper'>
        <div className='sitewidth text-center'>
          <h1 className='ideas-overview-wrapper-title'>Ideas</h1>
        </div>
        <br />
        <section>
          <div className='col col--main has--side'>
            <div className='list-widget-wrapper'>
              {
                ideas.map(idea => <IdeaView
                  {...idea}
                  isGuest={isGuest}
                  currentUserId={currentUserId}
                />)
              }
            </div>
          </div>
          <div className='col col--side Sidebarmodule qa-div-sidebar'>
            {/*{*/}
              {/*productAreas.length ? (*/}
                {/*<section className='widget'>*/}
                  {/*<ProductAreaFilter*/}
                    {/*onCallback={(status: string | null) => this.updateFilters('productArea', status)}*/}
                    {/*productAreas={productAreas}*/}
                    {/*selected={selectedFilters.productArea}*/}
                  {/*/>*/}
                {/*</section>*/}
              {/*) : null*/}
            {/*}*/}
            {
              ideationStatuses.length ? (
                <section className='widget'>
                  <IdeaStatusFilter
                    onCallback={(status: string | null) => this.updateFilters('ideationStatus', status)}
                    ideationStatuses={ideationStatuses}
                    selected={selectedFilters.ideationStatus}
                  />
                </section>
              ) : null
            }
          </div>
        </section>
      </div>
    )
  }
}

export default IdeasOverview
